<template>
  <div class="flex-none flex border-t border-gray-600">
    <div
      v-for="(day, index) in weekDays"
      :key="day"
      :class="{ 'border-l border-gray-600': index }"
      class="flex-1 bg-gray-500 text-center text-xs text-white font-medium tracking-wide p-2 uppercase"
    >
      {{ day }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    weekDays: {
      type: Array,
      required: true,
    },
  },
};
</script>
